import { useQuery } from '@tanstack/react-query';
import Api from '@/services/api';
import { BaseContext } from '@/types';
import { ROSA_QUERY_KEYS } from './query-keys';
import { RosaSubCategoryEnum } from '../Steps/Evaluation/constants';

export type RosaSubCategory = {
	id: string;
	description: string;
	name: RosaSubCategoryEnum;
};

export type GetRosaCategoriesResponse = {
	id: string;
	name: string;
	description: string;
	sub_categories: RosaSubCategory[];
};

async function getRosaCategories(params: BaseContext): Promise<GetRosaCategoriesResponse[]> {
	const url = `ergonomic-tool/rosa/categories`;
	const { data } = await Api.get<GetRosaCategoriesResponse[]>(url, { params });
	return data;
}

export const useGetRosaCategories = (params: BaseContext) => {
	return useQuery([ROSA_QUERY_KEYS.GET_CATEGORIES], () => getRosaCategories(params));
};
